module.exports = __webpack_public_path__ + "static/main-84358aa73cd6cec320c5749ab07b075e.png";